import React, { useState, useEffect } from "react";
import UserHeader from "./UserHeader";
import { ToastContainer, toast } from "react-toastify";
import { getUserSurveyDetails } from "../../Utils/userFunctions";
import { useParams, Link } from "react-router-dom";
import { get_Date, getSurveyStatusName } from "../../Utils/commonFunctions";
function UserSurveyDetails() {
  const [surveyData, setSurveyData] = useState("");
  const [surveyStatus, setSurveyStatus] = useState("");
  const { surveyID } = useParams();
  useEffect(() => {
    UserSurveyDetails();
  }, []);
  const UserSurveyDetails = async () => {
    const response = await getUserSurveyDetails(surveyID);
    if (response.status == "success") {
      console.log(response)
      setSurveyData(response.data[0]);
      setSurveyStatus(response.data[0].status);
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };
  return (
    <div>
      <UserHeader />
      <ToastContainer></ToastContainer>
      <div className="container">
        <div className="row mt-4">
          <div className="col-md-4">
            <div className="card vd-card">
              <div className="card-body">
                <div className="pmcf-content-info">
                  <span className="custom_survey_name">
                    {surveyData.survey_name}
                  </span>
                  <hr
                    style={{
                      border: "1px solid #006CB5",
                      borderRadius: 10,
                    }}
                  />

                  <div className="pmcf-survey-list" style={{ marginTop: "5%" }}>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Status</div>
                      <div className="pmcf-survey-value">
                        {getSurveyStatusName(surveyStatus)}
                      </div>
                    </div>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Launch Date</div>
                      <div className="pmcf-survey-value">
                        {surveyData.launch_date
                          ? get_Date(surveyData.launch_date)
                          : "Survey is yet to be launched"}
                      </div>
                    </div>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Completion Date</div>
                      <div className="pmcf-survey-value">
                        {get_Date(surveyData.completion_date)}
                      </div>
                    </div>
                  </div>
                  <div className="pmcf-survey-question-point">
                    <h2 style={{ color: "#006CB5" }}>
                      {" "}
                      {surveyData.no_of_question}
                    </h2>
                    <p style={{ color: "black" }}>QUESTIONS</p>
                  </div>
                  <div className="pmcf-survey-list">
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">
                        Number of Participants
                      </div>
                      <div className="pmcf-survey-value">
                        {" "}
                        {surveyData.no_of_paticipants}
                      </div>
                    </div>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Responses</div>
                      <div className="pmcf-survey-value">
                        {surveyData.no_of_responses} /{" "}
                        {surveyData.no_of_paticipants}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <div className="card vd-card">
              <p className="text-right m-2">
                <Link
                  to="/UserListSurveys"
                  className="btn btn-sm custom-btn-primary pull-right"
                >
                  <i className="fa fa-arrow-left"></i> Back
                </Link>
              </p>
              <div className="card-body">
                <div className="pmcf-content-info1">
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <div className="survey-card-media">
                        <img
                          className="logo-style"
                          src={surveyData.device__device_image}
                          alt="Logo image  not available"
                        />
                        <h6 style={{ fontSize: "14px !important" }}>
                          {surveyData.device__device_name}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="action-footer-info">
                    <div className="row">
                      <div className="col-md-12 text-center">
                        <div className="action-btn-info">
                          <Link
                            to={"/UserSurveyParticipantsDetails/" + surveyID}
                            className="btn btn-sm custom-btn-primary"
                          >
                            Participants List
                          </Link>

                          <Link
                            to={"/survey-form/preview/" + surveyID}
                            className="btn btn-sm custom-btn-primary "
                          >
                            Preview
                          </Link>
                          {(surveyStatus === "launched" ||
                            surveyStatus === "final_save" ||
                            surveyStatus === "completed" ||
                            surveyStatus === "survey_released" ||
                            surveyStatus === "survey_approved" ||
                            surveyStatus === "survey_closed") && (
                            <Link
                              to={"/survey-individual-responses/" + surveyID}
                              className="btn btn-sm custom-btn-primary "
                            >
                              Responses
                            </Link>
                          )}
                          {surveyData.analysis_active === 1 && (
                            <Link
                              to={"/manufacturer-create-analysis/" + surveyID}
                              className="btn btn-sm custom-btn-primary "
                            >
                              Analysis
                            </Link>
                          )}
                          {(surveyStatus === "survey_released" ||
                            surveyStatus === "survey_approved" ||
                            surveyStatus === "survey_closed") && (
                            <Link
                              to={
                                "/manufacturer/reports/analysis_report/" +
                                surveyID
                              }
                              className="btn btn-sm custom-btn-primary "
                            >
                              Report
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserSurveyDetails;
